import { Tooltip as BaseTooltip, TooltipProps as BaseTooltipProps, forwardRef } from '@chakra-ui/react';

import { rem } from '@bonusly/ds-utils';

// NOTE: The design system currently only supports the "small" size variant for the tooltip. The prop, although
// not affecting the styling of the component in any way, is included with the assumption that there may be
// alternative sizes for use in the future.

export type TooltipSize = 'sm';

export interface TooltipProps extends BaseTooltipProps {
	size?: TooltipSize;
}

const Tooltip = forwardRef((props: TooltipProps, ref) => {
	return (
		<BaseTooltip
			backgroundColor="secondary.bg"
			borderRadius="sm"
			color="white"
			fontSize="sm"
			maxW={rem(240)}
			openDelay={350}
			px={2}
			py={1}
			ref={ref}
			{...props}
		/>
	);
});

Tooltip.displayName = 'Tooltip';

export { Tooltip };
